<template>
  <div class="columns is-centered">
    <div class="column is-one-quarter">
      <section class="section">
        <div class="box">
          <figure class="image is-4by1">
            <img src="@/assets/abalogix_transparent.png">
          </figure>
          <form class="register" @submit.prevent="register">
            <div class="field">
              <label class="label">Full Name</label>
              <div class="control has-icons-left">
                <input required class="input" type="text" id="fullname" v-model="fullname">
                <span class="icon is-small is-left">
                  <i class="fas fa-id-card"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <label class="label">Username</label>
              <div class="control has-icons-left has-icons-right">
                <input
                  required
                  class="input"
                  :class="{'is-danger': error.userid}"
                  type="text"
                  id="userid"
                  v-model="userid"
                >
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </div>
              <p class="help is-danger" v-if="error.userid">This username is unavailable</p>
            </div>

            <div class="field">
              <label class="label">Password</label>
              <div class="control has-icons-left has-icons-right">
                <input
                  required
                  minlength="8"
                  class="input"
                  :class="{'is-danger': error.phash}"
                  type="password"
                  id="phash"
                  v-model="phash"
                >
                <span class="icon is-small is-left">
                  <i class="fas fa-lock"></i>
                </span>
              </div>
              <p class="help is-danger" v-if="error.phash">Password contains invalid characters</p>
            </div>

            <div class="field">
              <label class="label">Company</label>
              <div class="control has-icons-left has-icons-right">
                <input required class="input" type="text" id="company" v-model="company">
                <span class="icon is-small is-left">
                  <i class="fas fa-building"></i>
                </span>
              </div>
              <p class="help is-danger" v-if="error.company">This company name is unavailable</p>
            </div>

            <div class="field">
              <label class="label">Email</label>
              <div class="control has-icons-left has-icons-right">
                <input
                  required
                  class="input"
                  :class="{'is-danger': error.email}"
                  type="email"
                  id="email"
                  v-model="email"
                >
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </div>
              <p class="help is-danger" v-if="error.email">This email address is unavailable</p>
            </div>
            <div class="field">
              <div class="control">
                <button class="button is-block is-fullwidth is-link">Submit</button>
              </div>
            </div>
          </form>
          <div class="content">
            <BR/>
            <BR/>By clicking submit you agree to these
            <a
              @click="displayTermsAndConditions=true"
            >terms and conditions.</a>
          </div>
          <div class="modal is-clipped" :class="{'is-active': displayTermsAndConditions}">
            <div class="modal-background"></div>
            <div class="modal-card">
              <header class="modal-card-head">
                <p class="modal-card-title">Terms and Conditions</p>
                <button class="delete" aria-label="close" @click="displayTermsAndConditions=false"></button>
              </header>
              <section class="modal-card-body">
                <TermsConditions/>
                <hr>
                <SubscriptionTerms/>
              </section>
            </div>
          </div>
        </div>
        <p class="has-text-grey">Already have an account?</p>
        <router-link to="/">Click to Login</router-link>
      </section>
    </div>
  </div>
</template>

<script>
import TermsConditions from "@/components/TermsConditions.vue";
import SubscriptionTerms from "@/components/SubscriptionTerms.vue";

export default {
  components: {
    TermsConditions,
    SubscriptionTerms
  },
  data() {
    return {
      userid: "",
      email: "",
      phash: "",
      fullname: "",
      company: "",
      company_id: "",
      user_id: "",
      displayTermsAndConditions: false,
      error: {
        userid: false,
        email: false,
        company: false,
        phash: false
      }
    };
  },
  methods: {
    register: function() {
      this.error.userid = false;
      this.error.email = false;
      this.error.phash = false;
      let data = {
        userid: this.userid,
        email: this.email,
        phash: this.phash,
        fullname: this.fullname,
        company: this.company
      };
      this.$store
        .dispatch("register", data)
        .then(response => {
          this.$emit("display-component", {
            component: "pricingTable",
            company_record_id: response.data.company_record_id,
            user_record_id: response.data.user_record_id
          });
        })
        .catch(httpError => {
          switch (httpError.response.data.error) {
            case "username already exists":
              this.error.userid = true;
              break;

            case "email address already exists":
              this.error.email = true;
              break;

            case "error hashing passwords":
              this.error.phash = true;
              break;
          }
        });
    }
  }
};
</script>
